import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Promocao } from 'src/app/models/promocao';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Segmentacao } from 'src/app/models/segmentacao';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PromocaoService } from 'src/app/services/promocao.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SelecionaKitModalComponent } from 'src/app/modals/seleciona-kit-modal/seleciona-kit-modal.component';
import { ItemPedido } from 'src/app/models/pedido';
import { ProdutoService } from 'src/app/services/produto.service';
import { PremissasService } from 'src/app/services/premissas.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-promocao',
  templateUrl: './cadastrar-promocao.component.html',
  styleUrls: ['./cadastrar-promocao.component.scss']
})
export class CadastrarPromocaoComponent implements OnInit {
  promocao: Promocao = new Promocao();
  idPromocao: string;
  classificacoes: Segmentacao[];
  kitSelecionado;
  multiFornecedores = false;

  @ViewChild('promoImage', {static: false}) promoImage: ElementRef;
  @ViewChild('promoImageRegulamento', {static: false}) promoImageRegulamento: ElementRef;
  selectedFile: File;
  selectedFileRegulamento: File;
  campanha = false;
  tipoCampanha = 0;

  tiposCampanha = [
    { id: 0, nome: 'Comum' },
    { id: 1, nome: 'Mensal' },
  ];

  constructor(
    private segmentacaoService: SegmentacaoService,
    private utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private promocaoService: PromocaoService,
    private produtoService: ProdutoService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private premissasService: PremissasService
  ) {
    this.route.data.subscribe(data => {
      this.campanha = data['campanha'];
    });
  }

  ngOnInit(): void {

    this.buscarMultiFornecedores();

    if (this.route.snapshot.paramMap.get('id')) {
      this.idPromocao = this.route.snapshot.paramMap.get('id');
      this.buscarPromocao();
    } else {
      this.promocao = new Promocao();
      this.promocao.ativo = true;
    }

    this.buscarClassificacao();
  }

  selecionarKitFechado() {
    const dialogRef = this.dialog.open(SelecionaKitModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        itens: [],
        potTotal: 0,
        potenciaAte: 100,
        multiFornecedores: this.multiFornecedores
      },
      panelClass: 'modal-card',
      maxHeight: '90vh',
    });

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      if(result && result.length){
        this.promocao.idProduto = result[0].produtoTela.idProduto;
        this.buscarProduto();
      }
    });
  }

  limparKitSelecionado() {
    this.kitSelecionado = undefined;
  }

  buscarProduto() {
    this.carregandoService.mostra('buscarProduto');

    this.produtoService.consultarPorId(this.promocao.idProduto).subscribe(produto => {
      this.kitSelecionado = produto;

      if(this.kitSelecionado && this.kitSelecionado.idProduto) {
        this.kitSelecionado.imagem$ = this.buscarImagemProduto(this.kitSelecionado.idProduto);
      }

      this.carregandoService.esconde('buscarProduto');
    }, (erro) => {
      this.carregandoService.esconde('buscarProduto');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarImagemProduto(idProduto: number): Promise<string> {
    const imagem = await this.produtoService.consultarImagemProdutoPorId(idProduto).toPromise();

    if (imagem && imagem.url) {
      return Promise.resolve(imagem.url);
    } else if (imagem && imagem.raw) {
      return Promise.resolve("data:image/jpg;base64," + imagem.raw);
    } else {
      return Promise.resolve('./assets/img/inversor.png');
    }
  }

  buscarPromocao() {
    this.carregandoService.mostra('buscarPromocao');

    this.promocaoService.consultarPorId(this.idPromocao).subscribe(promocao => {
      this.promocao = promocao;

      this.tipoCampanha = this.promocao.tipoCampanha;

      if(this.promocao.idProduto) {
        this.buscarProduto();
      }

      this.carregandoService.esconde('buscarPromocao');
    }, (erro) => {
      this.carregandoService.esconde('buscarPromocao');
      this.notificacaoService.erro(erro);
    });
  }

  buscarClassificacao() {
    this.carregandoService.mostra('buscarClassificacao');

    this.segmentacaoService.consultar().subscribe(dados => {
      this.classificacoes = dados;
      this.carregandoService.esconde('buscarClassificacao');
    }, (erro) => {
      this.carregandoService.esconde('buscarClassificacao');
      this.notificacaoService.erro(erro);
    });
  }

  onFileChanged(event) {
    if(event.target.files[0].type !== 'image/jpeg') {
      this.promoImage.nativeElement.value = null;

      this.notificacaoService.erroMSG('Arquivo inválido, use arquivos com extensão .jpg');
      return;
    } else {
      this.selectedFile = event.target.files[0];
      this.promocao.imagem = '';
    }
  }

  onFileRegulamentoChanged(event) {
    if(event.target.files[0].type !== 'image/jpeg') {
      this.promoImageRegulamento.nativeElement.value = null;

      this.notificacaoService.erroMSG('Arquivo inválido, use arquivos com extensão .jpg');
      return;
    } else {
      this.selectedFileRegulamento = event.target.files[0];
      this.promocao.imagemRegulamento = '';
    }
  }

  excluirArquivo() {
    this.promocao.imagem = '';
    this.selectedFile = undefined;
  }

  excluirArquivoRegulamento() {
    this.promocao.imagemRegulamento = '';
    this.selectedFileRegulamento = undefined;
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  async salvar() {
    this.carregandoService.mostra('salvarPromocao');

    this.promocao.tipoCampanha = this.tipoCampanha;

    if(this.kitSelecionado) {
      this.promocao.idProduto = this.kitSelecionado.idProduto;
      this.promocao.nomeProduto = this.kitSelecionado.descricao;
    } else {
      this.promocao.idProduto = undefined;
      this.promocao.nomeProduto = undefined;
    }

    if (this.selectedFile) {
      this.promocao.imagem = (await this.utilitarioService.toBase64(this.selectedFile));
    }

    if (this.selectedFileRegulamento) {
      this.promocao.imagemRegulamento = (await this.utilitarioService.toBase64(this.selectedFileRegulamento));
    }

    this.promocao.campanha = this.campanha;

    this.promocaoService.salvar(this.promocao).subscribe(
      (retorno) => {
        this.notificacaoService.sucesso((this.campanha ? 'Campanha ' : 'Promoção') + ' salva com sucesso!!!');
        this.carregandoService.esconde('salvarPromocao');
        this.router.navigate([this.campanha ? 'configuracoes/campanhas' : '/configuracoes/promocao']);
      },
      (erro) => {
        this.carregandoService.esconde('salvarPromocao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  voltar() {
    this.router.navigate([this.campanha ? 'configuracoes/campanhas' : '/configuracoes/promocao']);
  }

  buscarMultiFornecedores() {

    this.carregandoService.mostra('buscarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;



        this.carregandoService.esconde('buscarMultiFornecedores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMultiFornecedores');
        this.notificacaoService.erro(erro);
      }
    );
  }
}
